import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';

// Medya yükleme: Cloudflare R2 + Worker (firebase.storage kullanılmaz).
const firebaseConfig = {
  apiKey: 'AIzaSyAgQ8Scy_aUkY7GA7pjJZhvvwbr-3a0HT0',
  authDomain: 'pinki-1c3fc.firebaseapp.com',
  projectId: 'pinki-1c3fc',
  storageBucket: 'pinki-1c3fc.firebasestorage.app',
  messagingSenderId: '887870575088',
  appId: '1:887870575088:web:fdc6416cd1318309840d35',
  measurementId: 'G-BN79QTD88J',
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const functions = getFunctions(app, 'us-central1');

export { app };
export default app;
